import Cookies from 'js-cookie';
import { COOKIE_FOR_MOBILE_NAME } from '../constants';
/**
 * Determines if the current page is being rendered within the mobile application (WebView).
 *
 * If the cookies object contains this key "mobile" with value "true", then it is a mobile application.
 *
 * @returns true or false
 */
export const isMobileApp = () => Cookies.get(COOKIE_FOR_MOBILE_NAME) === 'true';
/**
 * Determines if the current page is being rendered within a mobile screen.
 *
 * If the `navigator.userAgent` contains any mobile vendor, then it is a mobile view.
 *
 * @returns true or false
 */
export const isMobileView = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(navigator.userAgent);
/**
 * Sends a message to the hosting mobile-app device which opens this web application in a `WebView`
 *
 * @param message - The string message which will be sent to the WebView
 */
export const postMessageToWebView = (message) => {
    var _a;
    if (!isMobileApp())
        return;
    const msg = message instanceof Object ? JSON.stringify(message) : message;
    (_a = window === null || window === void 0 ? void 0 : window.ReactNativeWebView) === null || _a === void 0 ? void 0 : _a.postMessage(msg);
};
//# sourceMappingURL=mobileApp.js.map